import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { SWAL_UPLOAD, UPLOAD_DISPLAY_TEXT } from '../../shared/constants';
import { UploadLoopBackApiService as UploadService } from "../../services/api/loopback/custom/upload.service";
import { BaseHelperService } from '../../services/helper/base.service';
import { BaseValidator } from '../../services/validator/base.service';

declare const swal: any;

@Component({
  selector: 'drx-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent implements OnInit {

  @ViewChild('inputFile') inputFile: any;

  @Input() isMultiple: Boolean; // Optional
  @Input() container?: string; // Optional
  @Input() drag?: Boolean; // Optional

  @Output() isCompleted?: EventEmitter<any> = new EventEmitter<any>(); // Required

  private uploadId: string;
  private acceptFile: string = "";
  public files: Array<File> = [];
  public options: boolean = true; // true -> upload video. Otherwise -> upload thumbnail
  public isUploading: boolean = false; // Required
  public inProgressFiles: Array<any> = [];
  public displayText?: string;

  public constructor(
    protected uploadService: UploadService
  ) {
    this.container = this.container || 'files';
    this.isMultiple = this.isMultiple || false;
    this.uploadId = BaseHelperService.randomId('upload-');
    this.drag = this.drag || false;
  }

  public ngOnInit() {
    this.displayText = this.displayTextByContainer();
    this.acceptFile = BaseHelperService.getAcceptFileExtension(this.container);
    swal.setDefaults({
      allowOutsideClick: false,
      allowEnterKey: false,
      allowEscapeKey: false
    });
  }

  public fileChange(event: EventTarget) {
    const eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    const target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    const fileList: FileList = target.files;
    this.handleFileBeforeUpload(fileList);
  }

  public handleFileBeforeUpload(fileList) {
    for (let i = 0; i < fileList.length; i++) {
      const item = fileList[i];
      if (BaseValidator.checkMaxFileSize(item.size)) {
        swal(SWAL_UPLOAD.WARNING_MAX_SIZE);
        break;
      } else if (this.container === 'files' && !BaseValidator.isDocument(item.name)) {
        swal(SWAL_UPLOAD.FILE_TYPE_WARNING);
        break;
      } else if (this.container === 'images' && !BaseValidator.isImage(item.name)) {
        swal(SWAL_UPLOAD.IMAGE_EXTENSION_WARNING);
        break;
      } else if (this.container === 'audios' && !BaseValidator.isAudio(item.name)) {
        swal(SWAL_UPLOAD.AUDIO_EXTENSION_WARNING);
        break;
      }
      this.files.push(item);
    }
    if (this.files.length === fileList.length) {
      if (BaseValidator.isImage(this.files[0].name)) {
        this.validateImgDimension(this.files[0], this);
      } else {
        this.upload();
      }
    }
    this.inputFile.nativeElement.value = '';
  }

  public validateImgDimension(file, self): void {
    let _URL = window.URL || (window as any).webkitURL;
    let img = new Image();
    img.onload = () => {
      if (img.width > 1024 || img.height > 1024) {
        self.reset();
        swal(SWAL_UPLOAD.WARNING_IMG_DIMENSION);
      } else {
        self.upload();
      }
    };
    img.src = _URL.createObjectURL(file);
  }

  public upload() {
    const _self = this;
    let formData = new FormData();
    formData.append('file', this.files[0]);
    this.isUploading = true;
    this.uploadService.upload(this.container, formData)
    .subscribe(response => {
      this.completed(response['data']);
      this.reset();
    });
  }

  public completed(result) {
    // const uri = this.uploadService.getUri(result[0].container, result[0].name);
    const uri = 'uploads/' + result[0].container + '/' + result[0].name;
    this.isCompleted.emit(uri);
  }

  public reset() {
    this.files = [];
    this.isUploading = false;
    this.inProgressFiles = [];
  }

  public dropHandler(e) {
    e.preventDefault();
    // If dropped items aren't files, reject them
    const dt = e.dataTransfer;
    if (dt.files) {
      // Use DataTransfer interface to access the file(s)
      if (dt.files.length > 1) {
        swal(SWAL_UPLOAD.WARNING_MULTIPLE_FILES);
      } else {
        this.handleFileBeforeUpload(dt.files);
      }
    }
  }

  public dragoverHandler(e) {
    // Prevent default select and drag behavior
    e.preventDefault();
  }

  public dragendHandler(e) {
    // Remove all of the drag data
    const dt = e.dataTransfer;
    if (dt.files) {
      // Use DataTransfer interface to remove the drag data
      e.dataTransfer.clearData();
    }
  }

  public displayTextByContainer() {
    var text = UPLOAD_DISPLAY_TEXT.DOCUMENT;
    if (this.container === 'images') {
      text = UPLOAD_DISPLAY_TEXT.IMAGE;
    } else if (this.container === 'audios') {
      text = UPLOAD_DISPLAY_TEXT.AUDIO;
    }
    return text;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/upload-file/upload-file.component.ts